import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.colors.warning.surface};
  padding: ${props => `${props.theme.spacing.sp16} ${props.theme.spacing.sp24}`};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const ExceptionHeader = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const AlertInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
